var t={wrap:"styles_wrap__Q0MYC",img:"styles_img__XIzKP",text:"styles_text__ztTRH",bold:"styles_bold__tREnB"};export{t as default};
